import {DESK_SETTING, USER_USERS, DESK_DESK} from './endpoint'
import {
  CREATE_TIMING_SCHEME,
  GET_ALL_TIMING,
  GET_TIMING_SCHEME,
  EDIT_TIMING_SCHEME,
  DELETE_TIMING_SCHEME,
  EDIT_USER,
  GET_USER,
  CREATE_TEAMS,
  EDIT_TEAMS,
  GET_TEAMS_LIST,
  DELETE_TEAMS,
  GET_TEAM_DATA,
} from './types'
import {apiAction} from './api'

export function createTimingScheme(data) {
  return apiAction({
    url: `${DESK_SETTING}/org/timings`,
    method: 'POST',
    label: CREATE_TIMING_SCHEME,
    data,
    showToast: true,
    successMessage: 'Business Hours Created',
  })
}

export function getAllTimingScheme(data) {
  return apiAction({
    url: `${DESK_SETTING}/org/timings`,
    method: 'GET',
    label: GET_ALL_TIMING,
    data,
  })
}

export function getTimingScheme(id) {
  return apiAction({
    url: `${DESK_SETTING}/org/timings/${id}`,
    method: 'GET',
    label: GET_TIMING_SCHEME,
  })
}

export function deleteTimingScheme(id) {
  return apiAction({
    url: `${DESK_SETTING}/org/timings/${id}`,
    method: 'DELETE',
    label: DELETE_TIMING_SCHEME,
    showToast: true,
    successMessage: 'Business Hours Deleted',
  })
}

export function editingTimingScheme(id, data) {
  return apiAction({
    url: `${DESK_SETTING}/org/timings/${id}`,
    method: 'PUT',
    label: EDIT_TIMING_SCHEME,
    data,
    showToast: true,
    successMessage: 'Business Hours Updated',
  })
}

export function editUser(data, id) {
  return apiAction({
    url: `${USER_USERS}/${id}`,
    method: 'PUT',
    label: EDIT_USER,
    data,
    token: 'account',
    showToast: true,
    successMessage: 'User Updated',
  })
}

export function getUser(id, data) {
  return apiAction({
    url: `${USER_USERS}/${id}`,
    method: 'GET',
    label: GET_USER,
    data,
    token: 'account',
  })
}

export function createTeams(data) {
  return apiAction({
    url: `${DESK_DESK}/teams`,
    method: 'POST',
    label: CREATE_TEAMS,
    data,
    showToast: true,
    successMessage: 'Teams Created',
  })
}

export function getAllTeams() {
  return apiAction({
    url: `${DESK_DESK}/teams`,
    method: 'GET',
    label: GET_TEAMS_LIST,
  })
}

export function getTeamsData(id) {
  return apiAction({
    url: `${DESK_DESK}/teams/${id}`,
    method: 'GET',
    label: GET_TEAM_DATA,
  })
}

export function deleteTeam(id) {
  return apiAction({
    url: `${DESK_DESK}/teams/${id}`,
    method: 'DELETE',
    label: DELETE_TEAMS,
    showToast: true,
    successMessage: 'Team Deleted',
  })
}

export function editTeams(id, data) {
  return apiAction({
    url: `${DESK_DESK}/teams/${id}`,
    method: 'PUT',
    label: EDIT_TEAMS,
    data,
    showToast: true,
    successMessage: 'Teams Updated',
  })
}
